import React, { useState, useEffect } from 'react';
import { useTabStore } from '../store';
import { CONSTANTS } from '../constants/constants';
import HomeTab from './tabs/HomeTab';
import DescriptionTab from './tabs/DescriptionTab';
import ComponentsTab from './tabs/ComponentsTab';
import LocationTab from './tabs/LocationTab';
import TasksTab from './tabs/TasksTab';
import MessagesTab from './tabs/MessagesTab';
import Loading from './Loading';

const MainContent = () => {
  const { activeTab } = useTabStore();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => setIsLoading(false), 300); // Simulate loading
    return () => clearTimeout(timer);
  }, [activeTab]);

  const renderContent = () => {
      switch (activeTab) {
        case CONSTANTS.TABS.HOME:
          return <HomeTab />;
        case CONSTANTS.TABS.DESCRIPTION:
          return <DescriptionTab />;
        case CONSTANTS.TABS.COMPONENTS:
          return <ComponentsTab />;
        case CONSTANTS.TABS.LOCATION:
          return <LocationTab />;
        case CONSTANTS.TABS.TASKS:
          return <TasksTab />;
        case CONSTANTS.TABS.MESSAGES:
          return <MessagesTab />;
        default:
          return <HomeTab />;
      }
    };

  return (
    <div className="main-content">
      {isLoading ? (
        <Loading />
      ) : (
        renderContent()
      )}
    </div>
  );
};

export default MainContent;